<template>
  <div class="row">
    <div class="col-lg-12">
      <div class="card">
        <div class="card-body">
          <div class="card-title">
            Возможные принтеры для связки с id={{ currentFranchiseRelationId }}
            <p>"{{ currentFranchiseRelationTitle }}"</p>
          </div>
          <div class="row mt-3">
            <div class="col-lg-12">
              <table class="table table-hover" style="cursor: pointer;">
                <thead>
                <tr>
                  <th>ID Принтера</th>
                  <th>SN Принтера</th>
                  <th>Название</th>
                  <th>Привязка</th>
                  <th>Действия</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="item in partnerPrintersData.unattached_printers" :key="item.id">
                  <td>{{item.id}}</td>
                  <td>{{item.printer_id}}</td>
                  <td>{{item.printer.name}}</td>
                  <td>свободный</td>
                  <td>
                    <div @click="attachPrinter(item.printer_id)" class="btn btn-sm btn-outline-success">
                      <i class="fas"></i> Привязать
                    </div>
                  </td>
                </tr>
                <tr v-for="item in partnerPrintersData.my_printers" :key="item.id">
                  <td>{{item.id}}</td>
                  <td>{{item.printer_id}}</td>
                  <td>{{item.printer.name}}</td>
                  <td>привязан</td>
                  <td>
                    <div @click="detachPrinter(item.printer_id)" class="btn btn-sm btn-outline-danger">
                      <i class="fas"></i> Отвязать
                    </div>
                  </td>
                </tr>
                <tr v-for="item in partnerPrintersData.other_printers" :key="item.id">
                  <td>{{item.id}}</td>
                  <td>{{item.printer_id}}</td>
                  <td>{{item.printer.name}}</td>
                  <td>занят другим договором с id={{item.partner_id}}</td>
                  <td>
                  </td>
                </tr>
                <tr v-for="item in partnerPrintersData.invalid_printers" :key="item.id">
                  <td>{{item.id}}</td>
                  <td>{{item.printer_id}}</td>
                  <td></td>
                  <td class="text-danger">Нецелостные данные в БД</td>
                  <td>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>


        </div>
      </div>
    </div>
  </div>
</template>

<script>

import axios from "axios";

export default {
  name: "PossiblePrintersForPartner",
  mounted() {
  },
  props: {
    submitManagePartnerPrinters: Number
  },
  watch: {
    submitManagePartnerPrinters: function (val) {
      if (val > 0) {
        this.handleSubmitManagePartnerPrinters();
      }
    }
  },
  data() {
    return{
      currentPartnerId: null,
      currentFranchiseRelationId: null,
      currentFranchiseRelationTitle: null,
      partnerPrintersData: {
        unattached_printers: [{
          id: null,
          printer_id: null,
          partner_id: null,
          printer: {
            name: null
          },
        }],
        my_printers: [{
          id: null,
          printer_id: null,
          printer: {
            name: null
          },

        }],
        other_printers: [{
          id: null,
          printer_id: null,
          printer: {
            name: null
          },
        }],
        invalid_printers: [{
          id: null,
          printer_id: null,
        }],
      },
    }
  },

  methods: {
    attachPrinter(printerSerialNumber) {
      let formData = new FormData();
      formData.append('id', this.currentPartnerId);
      formData.append('printer_serial_number', printerSerialNumber);
      axios
          .post(`/v1/partners/attach-printer`, formData)
          .then()
          .catch(err => {
            this.$store.dispatch("addNotification", {
              text: err.response.data.message,
              time: 6,
              color: "danger"
            });
          })
          .finally(() => {
            this.getFranchiseRelationPrintersByPartnerId(
                this.currentPartnerId, this.currentFranchiseRelationId, this.currentFranchiseRelationTitle
            );
          })
      ;
      this.getFranchiseRelationPrintersByPartnerId(
          this.currentPartnerId, this.currentFranchiseRelationId, this.currentFranchiseRelationTitle
      );
    },
    detachPrinter(printerSerialNumber) {
      let formData = new FormData();
      formData.append('id', this.currentPartnerId);
      formData.append('printer_serial_number', printerSerialNumber);
      axios
          .post(`/v1/partners/detach-printer`, formData)
          .then()
          .catch(err => {
            this.$store.dispatch("addNotification", {
              text: err.response.data.message,
              time: 6,
              color: "danger"
            });
          })
          .finally(() => {
            this.getFranchiseRelationPrintersByPartnerId(
                this.currentPartnerId, this.currentFranchiseRelationId, this.currentFranchiseRelationTitle
            );
          })
      ;
    },
    getFranchiseRelationPrintersByPartnerId(currentPartnerId, franchiseRelationId, franchiseRelationTitle = null) {
      this.currentFranchiseRelationId = franchiseRelationId;
      if (franchiseRelationTitle !== null) {
        this.currentFranchiseRelationTitle = franchiseRelationTitle;
      }
      this.currentPartnerId = currentPartnerId;
      axios
          .get(`/v1/partners/get-printers-of-current-franchise-relation?id=` + this.currentPartnerId)
          .then(resp => {
            this.partnerPrintersData = resp.data;
          })
          .catch(err => {
            this.$store.dispatch("addNotification", {
              text: err.response.data.message,
              time: 6,
              color: "danger"
            });
          });
    },
    setNullPrintersData() {
      this.currentFranchiseRelationTitle = null;
      this.partnerPrintersData.unattached_printers = null;
      this.partnerPrintersData.attached_printers = null;
    },
    handleSubmitManagePartnerPrinters() {
      this.submitted = true;
      // stop here if form is invalid
      this.$v.partnerData.$touch();
      if (!this.$v.partnerData.$invalid) {
        this.$emit('submitManagePartnerPrinters', this.partnerData);
      }
    },
  }
}
</script>

<style scoped lang="scss">

</style>